import moment from 'moment';
import Vue from 'vue';

export default (productId, date) => (
  new Promise((resolve, reject) => (
    Vue.$http.get(`appointments/slots/${productId}?now=${moment().format('YYYY-MM-DD HH:mm')}&date=${date}`)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    })
  ))
);



// WEBPACK FOOTER //
// ./src/app/services/appointment/slots.js